import React, { FC } from 'react';
import styled from '@cthings.co/styled-components';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';
import { ReactComponent as Note } from '../../assets/Note.svg';
import { Text, TextType } from '@bit/first-scope.text';
import { CommonButton } from '../../components/commonButton/CommonButton';
import { useHistory } from '../../utils/react-router-dom-abstraction';
import { View } from '../../routes/routeInterfaces';
import { stringifyUrl } from 'query-string';
import { getPath } from '../../routes/paths';
import { selectLanguageStrings } from '../../app/state/user';
import { useSelector } from 'react-redux';
import { media } from '@cthings.co/styles-utils';

const Banner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  margin: 25px auto;
  max-width: 800px;
  width: 100%;
  height: 60px;
  background-color: ${colorFetch('red2')};
  color: ${colorFetch('pureWhite')};
  box-sizing: border-box;
  border-radius: 6px;
  gap: 18px;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  z-index: var(--snackbar-layer);

  ${media.tablet} {
    height: auto;
    padding: 20px;
  }

  ${media.semiTablet} {
    flex-direction: column;
    gap: 15px;
  } ;
`;

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  ${media.semiTablet} {
    align-items: flex-start;
  }
`;

const NoteIcon = styled(Note)`
  min-width: 30px;
`;

const StyledInfoText = styled(Text)`
  font-family: 'Poppins';
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: ${colorFetch('pureWhite')};

  ${media.tablet} {
    text-align: left;
  }

  ${media.semiTablet} {
    text-align: center;
  }
`;

const StyledButton = styled(CommonButton)`
  color: ${colorFetch('pureWhite')};
  background-color: transparent;
  border-color: ${colorFetch('pureWhite')};
  min-width: 170px;
  width: auto;
  &:hover {
    background-color: transparent;
  }
  ${media.semiTablet} {
    width: 100%;
  }
`;

interface NoBillingDetailsBannerProps {
  hideButton: boolean;
  isBlockingAccess?: boolean;
}

export const NoBillingDetailsBanner: FC<NoBillingDetailsBannerProps> = ({
  hideButton = false,
  isBlockingAccess = false,
  ...props
}) => {
  const history = useHistory();

  const languageStrings = useSelector(selectLanguageStrings);

  const descriptionText = isBlockingAccess
    ? languageStrings.accessToThePlatformBlocked
    : languageStrings.pleaseFillOutBillingInformation;
  const buttonText = isBlockingAccess ? languageStrings.goToInvoices : languageStrings.goToBillingDetails;

  const onClick = () => {
    history.push(
      stringifyUrl({
        url: isBlockingAccess ? getPath(View.BILLING_INVOICES) : getPath(View.BILLING_DETAILS),
      }),
    );
  };

  return (
    <Banner {...props}>
      <InfoWrapper>
        <NoteIcon />
        <StyledInfoText type={TextType.TEXT_14_WHITE}>{descriptionText}</StyledInfoText>
      </InfoWrapper>
      {!hideButton && <StyledButton onClick={onClick}>{buttonText}</StyledButton>}
    </Banner>
  );
};
